import { MdCheckCircle, MdClose, MdErrorOutline, MdInfoOutline, MdWarningAmber } from "react-icons/md";

/*
 * Kuest toast (components/ui/toast.tsx): bottom-right stack, card styling
 * (rounded-md border bg-popover shadow-lg p-4), a coloured status icon, title in
 * text-base font-medium, description text-sm muted, close (×) at the top right.
 */
const ICONS = {
  success: <MdCheckCircle className="h-5 w-5 text-yes" aria-hidden="true" />,
  info: <MdInfoOutline className="h-5 w-5 text-primary" aria-hidden="true" />,
  warning: <MdWarningAmber className="h-5 w-5 text-orange-400" aria-hidden="true" />,
  error: <MdErrorOutline className="h-5 w-5 text-no" aria-hidden="true" />,
};

export function ToastViewport({ children }) {
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-[calc(100%-2rem)] max-w-[22rem] flex-col gap-2">
      {children}
    </div>
  );
}

export function Toast({ type = "info", title, description, media, onDismiss, dismissLabel = "Dismiss" }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="wasaa-toast pointer-events-auto relative flex w-full flex-col gap-1 rounded-md border border-border bg-popover p-4 text-popover-foreground shadow-lg"
    >
      <div className="flex min-w-0 items-center gap-2.5 pr-8">
        {media || ICONS[type] || ICONS.info}
        {title && <p className="line-clamp-3 min-w-0 flex-1 break-words text-sm font-medium">{title}</p>}
      </div>
      {description && <p className="line-clamp-3 min-w-0 break-words text-sm leading-relaxed text-muted-foreground">{description}</p>}
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label={dismissLabel}
          title={dismissLabel}
          className="absolute right-2 top-2 inline-flex h-7 w-7 items-center justify-center rounded-sm text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
        >
          <MdClose className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}

export default Toast;
